(function () {
  'use strict';

  angular.module('app').component('featureCategoryList', featureCategoryList());

  function featureCategoryList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        loadingItems: '<',
        onShowItem: '&',
      },
      controller: FeatureCategoryListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/admin/feature-categories/feature-category-list/feature-category-list.component.html',
    };
  }

  FeatureCategoryListCtrl.$inject = ['UtilService', 'FeatureCategoryService'];

  function FeatureCategoryListCtrl(UtilService, FeatureCategoryService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = FeatureCategoryService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;

    function fetchResult() {
      vm.loadingItems = true;
      FeatureCategoryService.getFeatureCategories(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = FeatureCategoryService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      vm.onShowItem({ item: item, mode: mode });
    }
  }
})();
